export default __webpack_public_path__ + "static/MagneticFields-Thin-57d0f6c26be67c93669f141eb2d273a1.woff";